// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-cgu-tsx": () => import("./../../../src/pages/cgu.tsx" /* webpackChunkName: "component---src-pages-cgu-tsx" */),
  "component---src-pages-commande-tsx": () => import("./../../../src/pages/commande.tsx" /* webpackChunkName: "component---src-pages-commande-tsx" */),
  "component---src-pages-contact-tsx": () => import("./../../../src/pages/contact.tsx" /* webpackChunkName: "component---src-pages-contact-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-merci-tsx": () => import("./../../../src/pages/merci.tsx" /* webpackChunkName: "component---src-pages-merci-tsx" */),
  "component---src-pages-produits-tsx": () => import("./../../../src/pages/produits.tsx" /* webpackChunkName: "component---src-pages-produits-tsx" */)
}

